import iconTrue from "../assets/images/icon/true.png";

export const ThaiBanks = [
  { text: "ธ.กรุงเทพ", value: "bbl" },
  { text: "ธ.กสิกรไทย", value: "kbank" },
  { text: "ธ.กรุงไทย", value: "ktb" },
  { text: "ธ.ไทยพาณิชย์", value: "scb" },
  { text: "ธ.กรุงศรีอยุธยา", value: "bay" },
  { text: "ธ.ทหารไทยธนชาต", value: "ttb" }, // ชื่อย่อเดิมคือ TMB, Thanachart
  { text: "ธ.ซีไอเอ็มบี ไทย", value: "cimb" },
  { text: "ธ.สแตนดาร์ดชาร์เตอร์ด (ไทย)", value: "scbt" },
  { text: "ธ.ยูโอบี", value: "uob" },
  { text: "ธ.เกียรตินาคินภัทร", value: "kkp" },
  { text: "ธ.เกียรตินาคินภัทร", value: "KK" },
  { text: "ธ.แลนด์ แอนด์ เฮ้าส์", value: "lhb" },
  { text: "ธ.ไอซีบีซี (ไทย)", value: "icbc" },
  { text: "ธ.ไทยเครดิต เพื่อรายย่อย", value: "tcrb" },
  { text: "ธ.ธ.ก.ส", value: "baac" },
  { text: "ธ.อาคารสงเคราะห์", value: "ghb" },
  { text: "ธ.ออมสิน", value: "gsb" },
  { text: "ธ.อิสลามแห่งประเทศไทย", value: "ibank" },
  { text: "ธ.ดอยซ์แบงก์", value: "db" },
  { text: "ธ.บีเอ็นพี พารีบาส์", value: "bnp" },
  { text: "ธ.มิซูโฮ แบงก์", value: "mizuho" },
  { text: "ธ.เอชเอสบีซี", value: "hsbc" },
  { text: "ธ.เจพีมอร์แกน เชส", value: "jpm" },
  { text: "ธ.ซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น", value: "smbc" },
  { text: "ธ.ซิตี้แบงก์", value: "citibank" },
  { text: "ธ.แห่งประเทศจีน", value: "boc" },
  { text: "ธ.โอซีบีซี", value: "ocbc" },
  { text: "ธ.เมย์แบงก์", value: "maybank" },
  { text: "ธ.ไทยพาณิชย์ (สาขากรุงเทพฯ)", value: "scbl" }, // อันนี้อาจจะซ้ำกับ SCB หลัก แต่อาจมีกรณีพิเศษ
];

export const BankData = [
  {
    bankCode: "002",
    bankNameTH: "ธนาคารกรุงเทพ",
    lableRef: "เลขที่อ้างอิง", // เพิ่มค่าสำหรับ BBL
    bank_id: "bbl",
    bankNameEN: "Bangkok Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/BBL.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "004",
    bankNameTH: "ธนาคารกสิกรไทย",
    lableRef: "เลขที่รายการ", // ค่าที่คุณต้องการสำหรับ KBANK
    bank_id: "kbank",
    bankNameEN: "Kasikorn Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/KBANK.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "006",
    bankNameTH: "ธนาคารกรุงไทย",
    lableRef: "Ref.No.", // เพิ่มค่าสำหรับ KTB
    bank_id: "ktb",
    bankNameEN: "Krungthai Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/KTB.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "011",
    bankNameTH: "ธนาคารทหารไทยธนชาต",
    lableRef: "เลขที่อ้างอิง", // เพิ่มค่าสำหรับ TTB
    bank_id: "ttb",
    bankNameEN: "TMBThanachart Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/TTB.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "014",
    bankNameTH: "ธนาคารไทยพาณิชย์",
    lableRef: "รหัสอ้างอิง", // ค่าที่คุณต้องการสำหรับ SCB
    bank_id: "scb",
    bankNameEN: "Siam Commercial Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/SCB.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "017",
    bankNameTH: "ธนาคารซิตี้แบงก์ เอ็น.เอ. สาขากรุงเทพฯ",
    lableRef: "Reference No.", // ค่าเริ่มต้น/ทั่วไป
    bank_id: "citi",
    bankNameEN: "Citibank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/CITI.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "018",
    bankNameTH: "ธนาคารซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น",
    lableRef: "Reference No.", // ค่าเริ่มต้น/ทั่วไป
    bank_id: "smbc",
    bankNameEN: "Sumitomo Mitsui Banking Corporation",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/SMBC.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "020",
    bankNameTH: "ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย)",
    lableRef: "Reference No.", // ค่าเริ่มต้น/ทั่วไป
    bank_id: "scbt",
    bankNameEN: "Standard Chartered Bank (Thai)",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/SC.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "022",
    bankNameTH: "ธนาคารซีไอเอ็มบี ไทย",
    lableRef: "เลขที่รายการ", // เพิ่มค่าสำหรับ CIMB
    bank_id: "cimb",
    bankNameEN: "CIMB Thai Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/CIMB.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "024",
    bankNameTH: "ธนาคารยูโอบี (ไทย)",
    bank_id: "uob",
    bankNameEN: "United Overseas Bank (Thai)",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/UOB.png",
    lableRef: "เลขที่อ้างอิง", // เพิ่มค่าสำหรับ UOB
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "025",
    bankNameTH: "ธนาคารกรุงศรีอยุธยา",
    lableRef: "เลขที่รายการ", // เพิ่มค่าสำหรับ BAY
    bank_id: "bay",
    bankNameEN: "Bank of Ayudhya (Krungsri)",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/BAY.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "029",
    bankNameTH: "ธนาคารอินเดียนโอเวอร์ซีส์",
    lableRef: "Reference No.", // ค่าเริ่มต้น/ทั่วไป
    bank_id: "iob",
    bankNameEN: "Indian Oversea Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/IOB.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "030",
    lableRef: "เลขที่รายการ", // เพิ่มค่าสำหรับ GSB
    bankNameTH: "ธนาคารออมสิน",
    bank_id: "gsb",
    bankNameEN: "Government Savings Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/GSB.png",
    accountLength: 10, // หรือ 12, ขึ้นอยู่กับประเภทบัญชี
    disabled: false,
  },
  {
    bankCode: "031",
    bankNameTH: "ธนาคารฮ่องกงและเซี่ยงไฮ้ แบงกิ้งคอร์ปอเรชั่น สาขา กรุงเทพฯ",
    bank_id: "hsbc",
    bankNameEN: "Hongkong and Shanghai Banking Corporation",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/HSBC.png",
    accountLength: 10,
    lableRef: "Reference No.", // ค่าเริ่มต้น/ทั่วไป
    disabled: false,
  },
  {
    bankCode: "032",
    bankNameTH: "ธนาคารดอยซ์แบงก์ สาขากรุงเทพฯ",
    bank_id: "dbag",
    bankNameEN: "Deutsche Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/DBAG.png",
    lableRef: "Reference No.", // ค่าเริ่มต้น/ทั่วไป
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "033",
    bankNameTH: "ธนาคารอาคารสงเคราะห์",
    bank_id: "ghb",
    bankNameEN: "Government Housing Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/GHB.png",
    lableRef: "เลขที่รายการ", // เพิ่มค่าสำหรับ GHB
    accountLength: 9, // หรือ 12
    disabled: false,
  },
  {
    bankCode: "034",
    bankNameTH: "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
    lableRef: "เลขที่อ้างอิง", // เพิ่มค่าสำหรับ BAAC
    bank_id: "baac",
    bankNameEN: "Bank for Agriculture and Agricultural Cooperatives",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/BAAC.png",
    accountLength: 12,
    disabled: false,
  },
  {
    bankCode: "039",
    bankNameTH: "ธนาคารมิซูโฮ สาขากรุงเทพฯ",
    lableRef: "Reference No.", // ค่าเริ่มต้น/ทั่วไป
    bank_id: "mzh",
    bankNameEN: "Mizuho Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/MZH.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "045",
    bankNameTH: "ธนาคารบีเอ็นพี พารีบาส์ สาขากรุงเทพฯ",
    lableRef: "Reference No.", // ค่าเริ่มต้น/ทั่วไป
    bank_id: "bnp",
    bankNameEN: "BNP Paribas",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/BNP.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "052",
    bankNameTH: "ธนาคารแห่งประเทศจีน (ไทย)",
    lableRef: "Reference No.", // ค่าเริ่มต้น/ทั่วไป
    bank_id: "boc",
    bankNameEN: "Bank of China (Thai)",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/BOC.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "066",
    bankNameTH: "ธนาคารอิสลามแห่งประเทศ",
    lableRef: "เลขที่รายการ", // เพิ่มค่าสำหรับ IBANK
    bank_id: "ibank",
    bankNameEN: "Islamic Bank of Thailand",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/IBANK.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "067",
    bankNameTH: "ธนาคารทิสโก้",
    lableRef: "Reference No.", // ค่าเริ่มต้น/ทั่วไป
    bank_id: "tisco",
    bankNameEN: "Tisco Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/TISCO.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "069",
    lableRef: "เลขที่รายการ", // เพิ่มค่าสำหรับ KKP
    bankNameTH: "ธนาคารเกียรตินาคิน",
    bank_id: "KKP",
    bankNameEN: "Kiatnakin Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/KKP.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "070",
    bankNameTH: "ธนาคารไอซีบีซี (ไทย)",
    lableRef: "Reference No.", // ค่าเริ่มต้น/ทั่วไป
    bank_id: "icbc",
    bankNameEN: "Industrial and Commercial Bank of China (Thai)",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/ICBC.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "071",
    lableRef: "เลขที่รายการ", // เพิ่มค่าสำหรับ TCRB
    bankNameTH: "ธนาคารไทยเครดิต เพื่อรายย่อย",
    bank_id: "tcrb",
    bankNameEN: "Thai Credit Retail Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/TCRB.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "073",
    lableRef: "Reference No.", // เพิ่มค่าสำหรับ LHB
    bankNameTH: "ธนาคารแลนด์ แอนด์ เฮ้าส์",
    bank_id: "lhb",
    bankNameEN: "Land and Houses Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/LHB.png",
    accountLength: 10,
    disabled: false,
  },
  {
    bankCode: "098",
    bankNameTH: "ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย",
    lableRef: "เลขที่รายการ", // เพิ่มค่าสำหรับ SMEB
    bank_id: "smeb",
    bankNameEN: "SME Bank of Thailand",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/SMEB.png",
    accountLength: 10,
    disabled: false,
  },
];

export const BankDataSelector = [
  {
    bankCode: "004",
    bankNameTH: "ธนาคารกสิกรไทย",
    bank_id: "kbank",
    bankNameEN: "Kasikorn Bank",
    accountLength: 10,
    status: true,
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/KBANK.png",
  },
  {
    bankCode: "014",
    bankNameTH: "ธนาคารไทยพาณิชย์",
    status: true,
    bank_id: "scb",
    bankNameEN: "Siam Commercial Bank",
    accountLength: 10,
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/SCB.png",
  },
  {
    bankCode: "006",
    bankNameTH: "ธนาคารกรุงไทย",
    status: true,
    bank_id: "ktb",
    bankNameEN: "Krungthai Bank",
    accountLength: 10,
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/KTB.png",
  },
  {
    bankCode: "025",
    bankNameTH: "ธนาคารกรุงศรีอยุธยา",
    status: true,
    bank_id: "bay",
    bankNameEN: "Bank of Ayudhya (Krungsri)",
    accountLength: 10,
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/BAY.png",
  },
  {
    bankCode: "030",
    bankNameTH: "ธนาคารออมสิน",
    status: true, // ปิดการใช้งาน GSB ชั่วคราว
    bank_id: "gsb",
    bankNameEN: "Government Savings Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/GSB.png",
    accountLength: 12, // หรือ 12, ขึ้นอยู่กับประเภทบัญชี
  },
  {
    bankCode: "011",
    bankNameTH: "ธนาคารทหารไทยธนชาต",
    status: true,
    bank_id: "ttb",
    bankNameEN: "TMBThanachart Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/TTB.png",
    accountLength: 10,
  },
  {
    bankCode: "073",
    bankNameTH: "ธนาคารแลนด์ แอนด์ เฮ้าส์",
    status: true,
    bank_id: "lhb",
    bankNameEN: "Land and Houses Bank",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/LHB.png",
    accountLength: 10,
  },
  {
    bankCode: "070",
    bankNameTH: "ธนาคารไอซีบีซี (ไทย)",
    status: true,
    bank_id: "icbc",
    bankNameEN: "Industrial and Commercial Bank of China (Thai)",
    bankLogo: "https://assets.slipmate.ai/public/banks-logo/ICBC.png",
    accountLength: 10,
  },
  {
    bankCode: "TRUE",
    bankNameTH: "ทรูวอลเลท",
    status: true,
    bank_id: "true",
    bankNameEN: "True Wallet",
    bankLogo: iconTrue,
    accountLength: 10,
  },
];


// Card Deposit and Withdrawal Time Ranges for Banks
export const timeRangeData = [
  {
    timeRange: "ได้ตลอด", // กำหนดเป็น null สำหรับเวลาที่ไม่มีช่วงเวลาเฉพาะ
    bankName: "kbank",
    type: "Deposit",
  },
  {
    timeRange: "ได้ตลอด", // กำหนดเป็น null สำหรับเวลาที่ไม่มีช่วงเวลาเฉพาะ
    bankName: "ttb",
    type: "Deposit",
  },
  {
    timeRange: "ได้ตลอด", // กำหนดเป็น null สำหรับเวลาที่ไม่มีช่วงเวลาเฉพาะ
    bankName: "ICBC",
    type: "Deposit",
  },
  {
    timeRange: "ได้ตลอด", // กำหนดเป็น null สำหรับเวลาที่ไม่มีช่วงเวลาเฉพาะ
    bankName: "lhb",
    type: "Deposit",
  },
  {
    timeRange: "ได้ตลอด", // กำหนดเป็น null สำหรับเวลาที่ไม่มีช่วงเวลาเฉพาะ
    bankName: "TRUE",
    type: "Deposit",
  },
  {
    timeRange: "00.05-23.50",
    bankName: "bay",
    type: "Deposit",
  },
  {
    timeRange: "02.00-23.30",
    bankName: "ktb",
    type: "Deposit",
  },
  {
    timeRange: "00.30-23.50",
    bankName: "scb",
    type: "Deposit",
  },

  // ถอน

  {
    timeRange: "02.00-23.00",
    bankName: "ktb",
    type: "withdrawal",
  },
  {
    timeRange: "23.00-02.00",
    bankName: "kbank",
    type: "withdrawal",
  },
  {
    timeRange: "06.00-22.00",
    bankName: "gsb",
    type: "withdrawal",
  },
  {
    timeRange: "ตลอดเวลา", // กำหนดเป็น null สำหรับเวลาที่ไม่มีช่วงเวลาเฉพาะ
    bankName: "bay",
    type: "withdrawal",
  },
];
export const timeRange = (bank, type, t) => {
  let o = timeRangeData.find((i) => i.bankName === bank && i.type === type);
  if (!o) {
    return "-";
  }

  // let timezone =
  //   o?.timeRange === "ได้ตลอด" ? "" : `(${getFormattedTimezone()})`;
  return t(o?.timeRange); // + ` ${timezone}`
};
// END


// TABLE_DATA ข้อมูลตารางธนาคารและช่วงเวลาเปิดใช้งาน
export const TABLE_DATA = [
  {
    timeRange: null,
    bankLogo: "KBANK.png",
    bankName: "kbank",
    type: "Deposit",
    status: "Ready",
    note: "-",
    supported:"Business_Personal_Account",
    badgeColor: "blue",
    className: "Deposit fs-sm-11 fs-12",
  },
  {
    timeRange: null,
    bankLogo: "TTB.png",
    bankName: "ttb",
    type: "Deposit",
    status: "Ready", // ใช้ "maintenance" เพื่อแสดงสถานะระหว่างตรวจสอบ, Ready 
    note: "-",
    badgeColor: "rgb(45, 183, 245)",
    supported:"Business Account",
    className: "Deposit fs-sm-11 fs-12",
  },
  // {
  //   timeRange: null,
  //   bankLogo: "LHB.png",
  //   bankName: "lhb",
  //   type: "Deposit",
  //   status: "Ready", // ใช้ "maintenance" เพื่อแสดงสถานะระหว่างตรวจสอบ, Ready 
  //   note: "-",
  //   badgeColor: "rgb(45, 183, 245)",
  //   supported:"Business Account",
  //   className: "Deposit fs-sm-11 fs-12",
  // },
  {
    timeRange: null,
    bankLogo: "TRUE.png",
    bankName: "truewallet",
    type: "Deposit",
    status: "Ready", // ใช้ "maintenance" เพื่อแสดงสถานะระหว่างตรวจสอบ, Ready 
    note: "match ลูกค้าจากชื่อและเบอร์โทรศัพท์",
    supported:"E-Wallet",
    badgeColor: "orange",
    className: "Deposit fs-sm-11 fs-12",
  },
  {
    timeRange: null,
    bankLogo: "ICBC.png",
    bankName: "icbc",
    type: "Deposit",
    badgeColor: "rgb(45, 183, 245)",
    supported:"Business Account",
    status: "Ready",
    note: "-",
    className: "Deposit fs-sm-11 fs-12",
  },

  {
    timeRange: "00.05-23.50",//,
    bankLogo: "BAY.png",
    bankName: "bay",
    type: "Deposit",
    status: "Ready", // ปิดการใช้งานชั่วคราว, ใช้ "maintenance" เพื่อแสดงสถานะระหว่างตรวจสอบ, Ready
    badgeColor: "rgb(45, 183, 245)",
    supported:"Business Account",
    note: "วงเงินไม่เกิน 200,000.-",
    className: "Deposit fs-sm-11 fs-12",
  },
  {
    timeRange: "01.30-23.50",
    bankLogo: "SCB.png",
    bankName: "scb",
    type: "Deposit",
    status: "Ready",
    badgeColor: "rgb(45, 183, 245)",
    supported:"Business Account",
    note: "Deposit SCB",
    className: "Deposit text-wrap fs-sm-11 fs-12",
  },
  {
    timeRange: "02.00-23.30",
    bankLogo: "KTB.png",
    bankName: "ktb",
    badgeColor: "rgb(45, 183, 245)",
    supported:"Business Account",
    type: "Deposit",
    status: "Ready",
    note: "-",
    className: "Deposit fs-sm-11 fs-12",
  },
  {
    timeRange: '-',// null,
    bankLogo: "BAY.png",
    badgeColor: "rgb(45, 183, 245)",
    bankName: "bay",
    supported:"Business Account",
    type: "Withdrawal",
    status: "maintenance", // ใช้ "maintenance" เพื่อแสดงสถานะระหว่างตรวจสอบ, Ready 
    note: "otp_warning_message",
    className: "Withdrawal text-wrap fs-sm-11 fs-12",
  },
  {
    timeRange: "02.00-23.00",
    bankLogo: "KTB.png",
    badgeColor: "rgb(45, 183, 245)",
    supported:"Business Account",
    bankName: "ktb",
    type: "Withdrawal",
    status: "Ready",
    note: "-",
    className: "Withdrawal fs-sm-11 fs-12",
  },
  {
    timeRange: "06.00-22.00",
    badgeColor: "rgb(45, 183, 245)",
    supported:"Business Account",
    bankLogo: "GSB.png",
    bankName: "gsb",
    type: "Withdrawal",
    status: "Ready",
    note: "",
    className: "Withdrawal text-wrap fs-sm-11 fs-12",
  },
  {
    timeRange: "23.00-02.00",
    bankLogo: "KBANK.png",
    bankName: "kbank",
    type: "WithdrawalManual",
    badgeColor: "blue",
    status: "Ready",
    supported:"Business_Personal_Account",
    note: "system manual",
    className: "Withdrawal text-wrap fs-sm-11 fs-12",
  },
];